import React from "react";
import ContactSection from "../components/ContactSection";

function ContactUs() {
  return (
    <div>
      <ContactSection />
    </div>
  );
}

export default ContactUs;
